import kamala from '../../kamala'
import Tag from './Tag'
import TagGroup from './TagGroup'
import TagList from './TagList'

const KTagFamily = {
  install: function (Vue) {
    kamala(Vue)
    Vue.component(Tag.name, Tag)
    Vue.component(TagGroup.name, TagGroup)
    Vue.component(TagList.name, TagList)
  },
  KTag: Tag,
  KTagGroup: TagGroup,
  KTagList: TagList,
}

export { Tag, TagGroup, TagList }

export default KTagFamily
